import { Observable } from 'rxjs';
import {
  Component,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
} from '@angular/core';
// import { OwnershipTypeService } from '../../services/ownershiptype.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
} from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';
import Swal from 'sweetalert2';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Store } from '@ngrx/store';
import { OwnershipTypeDto } from '@cradua/data';

@Component({
  selector: 'cradua-ownershiptype',
  templateUrl: './ownershiptype.component.html',
  styleUrls: ['./ownershiptype.component.scss'],
})
export class OwnershiptypeComponent implements OnChanges {
  ownershiptypeForm: FormGroup;
  ownershiptypeFormArray: FormGroup;
  control = new FormControl();
  @Input() ownershiptypes: OwnershipTypeDto[];
  @Input() routeAnimationsElements: any;
  @Output() ownershiptype = new EventEmitter<OwnershipTypeDto[]>();
  @Output() deleteOwnershipTypeEvent = new EventEmitter<any>();

  selectedOwnershipType: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedIndex = null;
  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createOwnershipTypeForm();
  }

  createOwnershipTypeForm() {
    this.ownershiptypeForm = this.fb.group({
      OwnershipTypeName: ['', Validators.required],
      id: null,
    });
    this.ownershiptypeFormArray = this.fb.group({
      OwnershipTypes: this.fb.array([]),
    });
    this.setOwnershipType();
  }

  // method to display ownershiptypes
  setOwnershipType() {
    const control = this.ownershiptypeFormArray.controls
      .OwnershipTypes as FormArray;
    this.ownershiptypes.forEach((e) => {
      control.push(
        this.fb.group({
          OwnershipTypeName: e.OwnershipTypeName,
          id: e.id,
        })
      );
    });
  }

  // method to add OwnershipType
  addOwnershipType(value: OwnershipTypeDto) {
    const control = this.ownershiptypeFormArray.controls
      .OwnershipTypes as FormArray;
    control.insert(
      0,
      this.fb.group({
        OwnershipTypeName: value.OwnershipTypeName,
        id: null,
      })
    );
  }

  selectOwnershipType(value) {}

  // method to delete ownershiptype from arrary list
  deleteOwnershipType(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.ownershiptypeFormArray.controls
          .OwnershipTypes as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.ownershiptypes.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.ownershiptypes[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  addNew(formValue: OwnershipTypeDto) {
    if (this.ownershiptypeForm.invalid) {
      return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
    }
    if (this.selectedIndex != null) {
      this.ownershiptypeFormArray
        .get('OwnershipTypes')
        ['controls'][this.selectedIndex].patchValue({
          OwnershipTypeName: formValue.OwnershipTypeName,
        });
    } else {
      this.addOwnershipType(formValue);
    }
    this.selectedIndex = null;
    this.ownershiptypeForm.reset();
  }

  onEdit(index, value: OwnershipTypeDto) {
    console.log(index, value);
    this.selectedIndex = index;
    this.ownershiptypeForm.patchValue({
      OwnershipTypeName: value.OwnershipTypeName,
    });
  }

  onClearForm() {
    this.selectedIndex = null;
    this.ownershiptypeForm.reset();
  }

  onSubmit(formValue: OwnershipTypeDto[]) {
    this.ownershiptype.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.deleteOwnershipTypeEvent.emit(this.filteredDelete);
    }
  }
}
